import { translate } from '@/domains/core/localization/translate';
export const {
  sponsoredRecommendationTitle
} = translate({
  "sponsoredRecommendationTitle": "Similar items you might like"
});
export const {
  sponsoredRecommendationSubtitle
} = translate({
  "sponsoredRecommendationSubtitle": "Sponsored"
});